import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { timestampToNormalDateTime } from '../../../helpers/hours';
import { useNavigate } from 'react-router-dom';
import { updateNotification } from '../../../actions/notifications';
import { useSelector } from 'react-redux';
import { Alert } from '@mui/material';
import { copy2Clipboard, handleSuccess } from '../../../helpers/utils';

export const NotificationCard = ({ data, handleClose }) => {
	const navigate = useNavigate();
	const { user = null } = useSelector((state) => state);

	const handleGoToOrder = (id) => {
		// Path
		const path = `/dashboard/order/${id}`;

		// Set local storage
		localStorage.setItem('currentPathPilu', path);

		handleClose();

		// Navigate to path
		navigate(path);
	};

	return (
		<Card sx={{ minWidth: 275, margin: '10px 0' }}>
			<CardContent>
				<Typography
					sx={{ fontSize: 14 }}
					color='text.secondary'
					gutterBottom
				>
					{timestampToNormalDateTime(data.created)}
					{user?.email === 'flopezramirez@hotmail.com' && (
						<>
							<br />
							<small
								style={{ cursor: 'pointer' }}
								onClick={() => {
									copy2Clipboard(data.id);
									handleSuccess('ID copiado');
								}}
							>
								{data.id}
							</small>
						</>
					)}
				</Typography>
				<Typography variant='h5' component='div'>
					{data.division} - {data.order.number_order}
				</Typography>
				<Typography sx={{ mb: 1.5 }} color='text.secondary'>
					{data.user.name}
				</Typography>
				<Typography variant='body2'>{data.message}</Typography>
			</CardContent>

			{[1, 3].includes(user?.area?.id) ||
			user?.user_type?.id === 2 ||
			user?.email?.includes('flope') ? (
				<>
					<CardActions>
						<Button
							size='small'
							onClick={() => {
								handleGoToOrder(data.order.id);
							}}
						>
							Ir a la orden
						</Button>
						<Button
							size='small'
							color={data.isDone ? 'error' : 'success'}
							onClick={() => {
								updateNotification(data.id, data.isDone, user);
							}}
						>
							Marcar como {data.isDone && 'no'} revisado
						</Button>
					</CardActions>
				</>
			) : (
				<Alert severity={data.isDone ? 'success' : 'warning'}>
					{data.isDone
						? `Notificación revisada por ${
								data?.reviewed_by?.name || 'Logística'
						  }`
						: 'Aún no se revisa'}
				</Alert>
			)}
		</Card>
	);
};
